import _ from 'lodash'
export default {
  data () {
    return {
      // In-flight lock: a double-click on save must not dispatch twice.
      submitting: false
    }
  },
  methods: {
    resolveFormErrorMessage (results, fallback = 'Unable to save changes. Please try again.') {
      const responseErrors = results?.error?.data?.errors || results?.response?.data?.errors
      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        return responseErrors[0]
      }

      if (responseErrors && typeof responseErrors === 'object') {
        const flattenedErrors = Object.values(responseErrors).reduce((acc, value) => {
          if (Array.isArray(value)) {
            return acc.concat(value)
          }
          acc.push(value)
          return acc
        }, [])
        const firstError = flattenedErrors.find(Boolean)
        if (firstError) {
          return firstError
        }
      }

      if (results?.error?.data?.message) {
        return results.error.data.message
      }

      if (results?.error?.message) {
        return results.error.message
      }

      if (results?.response?.data?.message) {
        return results.response.data.message
      }

      return fallback
    },
    async createOrUpdate (emitEvent = 'success') {
      if (this.submitting) {
        return
      }
      this.submitting = true
      this.$nuxt.$loading.start()
      try {
        if (this.formData.id) {
          const dirtyData = this.onlyDirty(this.formData)

          if (Object.keys(dirtyData).length === 0) {
            this.showSuccessSnack('No changes detected.')
            this.$emit(emitEvent, { ...this.formData })
            return
          }

          const obj = {
            id: this.formData.id,
            payload: dirtyData
          }
          const results = await this.$store.dispatch(`${this.schema.formconfig.model}/update`, obj)
          if (results && !results.isAxiosError && !this.objHas(results, 'error') && !results?.response?.data?.errors) {
            this.$emit(emitEvent, { ...results })
          } else {
            this.showErrorSnack(this.resolveFormErrorMessage(results))
          }
        } else {
          const cleanData = this.cleanResource(this.formData)
          const results = await this.$store.dispatch(
            `${this.schema.formconfig.model}/create`,
            cleanData
          )
          if (results && !results.isAxiosError && !this.objHas(results, 'error') && !results?.response?.data?.errors) {
            this.$emit(emitEvent, () => this.$refs[this.schema.formconfig.key].reset())
          } else {
            this.showErrorSnack(this.resolveFormErrorMessage(results))
          }
        }
      } catch (error) {
        this.showErrorSnack(error?.message || 'Unable to save changes. Please try again.')
      } finally {
        this.submitting = false
        this.$nuxt.$loading.finish()
      }
    },
    async subCreateOrUpdate () {
      if (this.submitting) {
        return
      }
      this.submitting = true
      this.$nuxt.$loading.start()
      try {
        if (this.formData.subId) {
          const onlyDirty = this.onlyDirty(this.formData)
          const payload = {
            parentId: this.parentId,
            subId: this.formData.subId,
            repositoryPath: this.schema.repositoryPath,
            subModel: this.schema.model,
            onlyDirty
          }

          const results = await this.$store.dispatch(
            `${this.schema.returns}/subUpdate`,
            payload
          )
          if (results && !results.isAxiosError && !this.objHas(results, 'error') && !results?.response?.data?.errors) {
            this.$emit('success', { ...results.data })
          } else {
            this.showErrorSnack(this.resolveFormErrorMessage(results))
          }
        } else {
          const cleanData = this.cleanResource(this.formData)
          const payload = {
            id: this.parentId,
            repositoryPath: this.schema.repositoryPath,
            subModel: this.schema.model,
            cleanData
          }
          const results = await this.$store.dispatch(
            `${this.schema.returns}/subCreate`,
            payload
          )

          if (results && !results.isAxiosError && !this.objHas(results, 'error') && !results?.response?.data?.errors) {
            this.$emit('success', { ...results.data })
          } else {
            this.showErrorSnack(this.resolveFormErrorMessage(results))
          }
        }
      } catch (error) {
        this.showErrorSnack(error?.message || 'Unable to save changes. Please try again.')
      } finally {
        this.submitting = false
        this.$nuxt.$loading.finish()
      }
    },
    cleanResource (data) {
      const resource = JSON.parse(JSON.stringify(data))
      for (const property in data) {
        if (data[property] === '') {
          // don't submit empty strings to the api
          delete resource[property]
        }
      }
      return resource
    },
    onlyDirty (data) {
      const resource = JSON.parse(JSON.stringify(data))
      for (const property in data) {
        if (_.isEqual(data[property], this.originalData[property])) {
          delete resource[property]
        }
      }
      return resource
    },
    showIfLengthGreaterThan (field, value) {
      return false
      // return this.formData[field].length > value
    }
  }
}
